import React from 'react';
import { useTranslation } from 'react-i18next';
import { AuthLayout } from '../components/AuthLayout';
import { RegisterForm } from '../components/forms/RegisterForm';

export const RegisterPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <AuthLayout
      title={t('auth.register.title')}
      subtitle={t('auth.register.subtitle')}
    >
      <RegisterForm />
    </AuthLayout>
  );
};
